export enum GLOBAL_SETTING_TYPE {
  BOOLEAN = 'boolean',
  INT = 'int',
  STRING = 'string',
  DATE_TIME = 'datetime',
}

export type GlobalSetting = {
  settingId: number;
  settingName: string;
  settingValue: string;
  settingType: GLOBAL_SETTING_TYPE;
  settingSortOrder: number;
  settingGroup: {
    settingGroupDisplayName: string;
    settingGroupSortOrder: number;
  };
  settingSubGroup: {
    settingSubGroupDisplayName: string;
    settingSubGroupSortOrder: number;
  };

  //form only
  isEdit?: boolean;
  tempSettingValue?: string;
};

export type GlobalSettings = GlobalSetting[];

export type AuditGlobalSetting = {
  id: string;
  date: Date;
  user: string;
  settingName: string;
  oldValue: string;
  newValue: string;
  username: string;
  userType: null;
};

export enum GLOBAL_SETTING_KEY {
  PASSWORD_RESET_MONTHS = 'PasswordResetMonths', //pragma: allowlist secret
  FIRST_TIME_LOGIN_VALID_HOURS = 'FirstTimeLoginValidHours', //pragma: allowlist secret
}

export type UpdateGlobalSettingPayload = {
  settingId: number;
  value: string;
  settingName?: string;
  groupIndex?: number;
  itemIndex?: number;
  subGroupIndex?: number;
};
